import React from "react";
import "./Styles/sectionSeparator.css";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const SectionSeparator = ({ label, mode="default" }) => {
    
    return (
        <div className={mode == "default" ? "section-separator" : "section-separator section-white"}>
            <div>
                <h2>{label}</h2>
                <a href="/boutique">Voir Tout <ArrowRightIcon/></a>
            </div>
            <span><span></span></span>
        </div>
    )
}